import Dexie, { Table } from 'dexie';
import {
  DbBrand,
  DbSeries,
  DbFlavor,
  DbFlavorTasteVectorMaster,
  DbUserFlavor,
  DbUserFlavorTasteVector,
  DbMix,
  DbMixFlavor,
} from './LocalDatabase';

export class AppDatabase extends Dexie {
  brands!: Table<DbBrand, string>;
  series!: Table<DbSeries, string>;
  flavors!: Table<DbFlavor, string>;
  flavorTasteMaster!: Table<DbFlavorTasteVectorMaster, string>;
  userFlavors!: Table<DbUserFlavor, string>;
  userFlavorTaste!: Table<DbUserFlavorTasteVector, string>;
  mixes!: Table<DbMix, string>;
  mixFlavors!: Table<DbMixFlavor, string>;

  constructor() {
    super('HookahForgeDB');
    this.version(1).stores({
      brands: 'id, name',
      series: 'id, name',
      flavors: 'id, brand_id, series_id, name',
      flavorTasteMaster: 'flavor_id',
      userFlavors: 'id, user_id, flavor_id, owned',
      userFlavorTaste: 'user_flavor_id',
      mixes: 'id, user_id, is_public, rating, created_at',
      mixFlavors: 'id, mix_id, flavor_id',
    });
    this.version(2).stores({
      brands: 'id, name',
      series: 'id, name',
      flavors: 'id, brand_id, series_id, name',
      flavorTasteMaster: 'flavor_id',
      userFlavors: 'id, user_id, flavor_id, owned',
      userFlavorTaste: 'user_flavor_id',
      mixes: 'id, user_id, is_public, is_favorite, rating, created_at',
      mixFlavors: 'id, mix_id, flavor_id',
    });
  }
}

export const db = new AppDatabase();
